import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { landingPageImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="Which fields are mandatory to preview the buyer registration page?"
      />
    ),
    answer: (
      <div>
        You need to fill the mandatory fields in Buyer registration page
        branding section and the Heading message field inside Buyer registration
        page configuration.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="What will the redirect URL be used for?"
      />
    ),
    answer: (
      <div>
        After a user submits the details on the buyer registration page, your
        customers will be redirected to any URL of your choice. For example -
        your company’s website, your app’s login page, etc. This is an optional
        field for you to add.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="What is Redirect in seconds?"
      />
    ),
    answer: (
      <div>
        If you have chosen a redirect URL, the redirect seconds you add will
        determine how long after submitting the details on the buyer
        registration page your customers will be redirected to the other URL.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="What is New customer message?"
      />
    ),
    answer: (
      <div>
        Any new customer who has bought your product will be redirected to the
        buyer registration page, and you can choose to customize the messaging
        shown to them on this page.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="Where and when will form submission message be shown?"
      />
    ),
    answer: (
      <div>
        Once the user has filled up the entire form which is shown in the buyer
        registration page and then submit the details, a success message will be
        shown in the same screen. You can see the demo at the top of screen.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="Where will Heading message be shown?"
      />
    ),
    answer: (
      <div>
        This will be shown as a heading at the top of the input fields on the
        buyer registration page. You can view this at the top in the demo buyer
        registration page attached.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="Is providing a privacy policy mandatory?"
      />
    ),
    answer: <div>No, providing a privacy policy is optional for you.</div>,
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="Where will Email custom message be shown, and when will this email be sent to my customers?"
      />
    ),
    answer: (
      <div>
        Your customers will receive an email once they submit the buyer
        registration page form. The message of this email can be customized as
        per onboarding instructions you want to give to your clients.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_CONFIGURATION
        }
        question="What is an existing buyer message?"
      />
    ),
    answer: (
      <div>
        This is a message that will be shown to an existing buyer when they
        renew or purchase your subscription again.
      </div>
    ),
  },
]

interface FlyoutProductLandingPageConfigurationFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductLandingPageConfigurationFaqs: React.FC<
  FlyoutProductLandingPageConfigurationFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Landing Page Configuration"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={[
          ...landingPageImages.slice(0, 2),
          ...landingPageImages.slice(-1),
        ]}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
